import {all, call, put, takeEvery} from 'redux-saga/effects';
import {
  PeopleActionTypes,
  fetchError,
  fetchSuccess,
  createError,
  createSuccess,
  deleteError,
  deleteSuccess,
  updateSuccess, updateError,
  fetchItemSuccess, fetchItemError
} from '@actions/people';
import peopleApi from '@api/person';
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(peopleApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err.stack!))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(peopleApi.delete, payload);
    yield put(deleteSuccess(payload.params))
  } catch (err) {
    yield put(deleteError(err.stack!))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(peopleApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  } catch (err) {
    yield put(createError(err.stack!));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(peopleApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(updateSuccess(data))
  } catch (err) {
    yield put(updateError(err.stack!));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleFetchItem({payload}: ReduxAction) {
  try {
    const res = yield call(peopleApi.getItem, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(fetchItemSuccess(res.data))
  } catch (err) {
    yield put(fetchItemError(err.stack!))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* peopleSaga() {
  yield all([
    yield takeEvery(PeopleActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(PeopleActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(PeopleActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(PeopleActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(PeopleActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
  ])
}

export default peopleSaga
